(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/use-custom-events.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/use-custom-events.js');
"use strict";

const {
  useEffect
} = React;
const useCustomEvents = _ref => {
  let {
    ticketInfo,
    isFullScreenGame,
    history,
    nextVoucher,
    match,
    dispatch
  } = _ref;
  const handleBetDone = _ref2 => {
    let {
      detail
    } = _ref2;
    const {
      receiptId,
      data
    } = detail;
    dispatch({
      type: 'SET_BET_ID',
      payload: data.id
    });
    svs.utils.paramHandler.set({
      key: 'wagerId',
      value: receiptId
    });
  };
  const getLocationBase = ticketInfo => {
    if (ticketInfo.name.toLowerCase().indexOf('triss') + 1) {
      return svs.core.urlMapping.get('trissHome');
    }
    return svs.core.urlMapping.get('skrapspelHome');
  };
  const handleGoToNext = () => {
    history.push("../../".concat(match.params.giftCode));
    history.push("".concat(match.params.giftCode, "/spela/").concat(nextVoucher.voucherId));
  };
  const onPlayAgain = e => {
    e === null || e === void 0 || e.preventDefault();
    if (nextVoucher) {
      handleGoToNext(e);
    } else {
      const ticketAvailable = ticketInfo.open;
      ticketAvailable && svs.ticketgames.ticketUtility.utils.tracking.trackChooseNewTicket(ticketInfo.type);
      svs.ticket_gifts.redeem.components.util.redirectToTicketSelector("".concat(getLocationBase(ticketInfo), "/valja/").concat(ticketInfo.type));
    }
  };
  useEffect(() => {
    const customEvents = [{
      eventName: 'HAS_BET',
      handler: handleBetDone
    }, {
      eventName: 'GAME_LOADING',
      handler: () => {
        svs.ticket_gifts.redeem.components.util.scrollTopContent();
        svs.ticket_gifts.redeem.components.util.hideHeaders();
      }
    }, {
      eventName: 'HAS_CLAIMED',
      handler: () => {
        svs.ticket_gifts.redeem.components.util.scrollTopContent();
        svs.ticket_gifts.redeem.components.util.showTopHeader(true);
      }
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: () => {
        svs.ticket_gifts.redeem.components.util.scrollTopContent();
        svs.ticket_gifts.redeem.components.util.showTopHeader(true);
      }
    }];
    customEvents.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      customEvents.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, []);
  return {
    isFullScreenGame,
    onPlayAgain
  };
};
setGlobal('svs.ticket_gifts.redeem.components.useCustomEvents', useCustomEvents);

 })(window);